import React, { useState } from "react";
import compoundImg from "assets/images/bg.png";
import developerdImg from "assets/images/developer_logo.png";
import { Card, CardImg, CardBody, CardText, Badge, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toCurrency } from "helpers/common";
import CallModal from "./Modal/CallModal";
import InterestServices from "services/Website/InterestServices";
import { toast } from "react-toastify";
import { addInterest } from "store/Auth/actions";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import MessageModal from "components/Website/Cards/MessageModal";

const CardComponent = ({ item, history }) => {
	const AuthData = useSelector((state) => state.Auth);
	const { t } = useTranslation();
	const [interestLoading, setInterestLoading] = useState(false);
	const interestServices = new InterestServices();
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const dispatch = useDispatch();

	const isInterested = () => {
		const id = parseInt(item?.id);
		return AuthData.interestsUnits.includes(id);
	};

	const interestHandler = () => {
		const data = { unit_id: item?.id };
		setInterestLoading(true);
		if (!isInterested()) {
			interestServices.createInterest(data).then((response) => {
				if (response && response.status === SuccessCreated) {
					toast.success("Unit Added to Your Interests Successfully");
					dispatch(
						addInterest({
							interestsUnits: [...AuthData.interestsUnits, item.id],
						})
					);
					setInterestLoading(false);
				}
			});
		} else {
			interestServices.deleteInterest(data).then((response) => {
				if (response && response.status === SuccessOk) {
					toast.success("Unit removed from Your interests");
					const updatedInterests = AuthData.interestsUnits.filter(
						(data) => data !== item?.id
					);
					dispatch(addInterest({ interestsUnits: updatedInterests }));
					setInterestLoading(false);
				}
			});
		}
	};

	return (
		<div className="websitPages">
			<div>
				<Card
					className="comCard me-2 rounded-4"
					onClick={() => history.push(`/property-details/${item?.id}`)}>
					<div className="row g-0">
						<div className="col-md-4">
							{item?.images?.length > 0 ? (
								<img src={item?.images?.[0].path} className="imageInside" />
							) : (
								<img className="imageInside" src={compoundImg} />
							)}
							{item?.developer?.media?.path ? (
								<img src={item.developer.media.path} className="imgAbsolute" />
							) : (
								<img src={developerdImg} className="imgAbsolute" />
							)}
							{/*<CardImg src={compoundImg} className='imageInside'></CardImg>*/}
							{/*<img src={developerdImg} className='imgAbsolute' />*/}
						</div>
						<div className="col-md-8">
							<CardBody>
								{/* <Badge className="bgBadgeResale bg-primary  badgeAbsolute font-size-12 me-3">{item?.unit_type?.name[`${AuthData.lang}`] ? item?.unit_type?.name[`${AuthData.lang}`] : item?.unit_type?.name?.en}</Badge> */}
								<div className="maxBodyHeightNew">
									<CardText
										tag="h4"
										className="font-size-16"
										style={{ color: "#3a3335", fontWeight: 800 }}>
										{item?.name[`${AuthData.lang}`]
											? item?.name[`${AuthData.lang}`]
											: item?.name?.en}
									</CardText>
									{/* <CardText tag="h5" className="font-size-16">{item?.unit_type?.name[`${AuthData.lang}`] ? item?.unit_type?.name[`${AuthData.lang}`] : item?.unit_type?.name?.en}</CardText> */}
									<CardText
										tag="h4"
										className="mb-1 d-flex justify-content-between">
										<span className="font-size-16 pt-1">
											{toCurrency(item?.price)} {t("egp")}
										</span>
										<Badge className="bg-primary p-2 font-size-12">
											{item?.finishing_type?.name[`${AuthData.lang}`]
												? item?.finishing_type?.name[`${AuthData.lang}`]
												: item?.finishing_type?.name.en}
										</Badge>
									</CardText>
									<div className="d-flex py-2 ">
										{!!item?.bedrooms && (
											<p className="w-100 text-black my-0">
												<i className="fa me-1 fa-bed"></i> {item?.bedrooms}{" "}
												{t("beds")}
											</p>
										)}
										{!!item?.bathrooms && (
											<p className="w-100 text-black my-0">
												<i className="fa me-1 fa-shower"></i> {item?.bathrooms}{" "}
												{t("baths")}
											</p>
										)}
										{!!item?.size && (
											<p className="w-100 text-black my-0">
												<i className="fa me-1 fa-exchange-alt"> </i>{" "}
												{parseInt(item?.size).toFixed(0)} {t("sqm")}
											</p>
										)}
									</div>
									{!!item?.floor && (
										<p className="w-100 text-black mb-2">
											<i className="fas me-1 fa-door-open"> </i>{" "}
											{parseInt(item?.floor)} {t("Floor No.")}
										</p>
									)}
									{(!!item?.address?.en ||
										!!item?.area?.name?.en ||
										!!item?.city?.name?.en) && (
										<p className="w-100 text-black address-compound">
											<i className="fas me-1 fa-map-marker-alt"></i>
											{item?.address[`${AuthData?.lang}`]
												? item?.address[`${AuthData?.lang}`]
												: item?.address?.en}
											,
											{item?.area?.name[`${AuthData?.lang}`]
												? item?.area?.name[`${AuthData?.lang}`]
												: item?.area?.name?.en}
											,
											{item?.city?.name[`${AuthData?.lang}`]
												? item?.city?.name[`${AuthData?.lang}`]
												: item?.city?.name?.en}
										</p>
									)}
								</div>
								<div className="d-flex">
									<div className="w-100">
										<button
											className="w-100 btn btnCall text-center"
											onClick={(e) => {
												e.stopPropagation();
												setCallModal(true);
											}}>
											<i className="fas fa-phone-alt pe-2"></i>
											{t("call")}
										</button>
									</div>
									<div className="mx-2 w-100">
										<button
											className="w-100 btn btnMessage text-center"
											onClick={(e) => {
												e.stopPropagation();
												setMessageModal(true);
											}}>
											<i className="fa fa-envelope"></i>
										</button>
									</div>
									<div className="mx-2 w-100">
										{interestLoading ? (
											<div className="w-100 d-flex justify-content-center pt-2">
												<Spinner size="sm" color="primary" />
											</div>
										) : (
											<div className="w-100">
												<button
													className="w-100 btn btnMessage text-center"
													onClick={(e) => {
														e.stopPropagation();
														interestHandler();
													}}>
													{isInterested() ? (
														<i className="fas fa-heart text-danger"></i>
													) : (
														<i className="far fa-heart text-danger"></i>
													)}
												</button>
											</div>
										)}
									</div>
								</div>
							</CardBody>
						</div>
					</div>
				</Card>
			</div>
			{callModal && (
				<CallModal
					modal={callModal}
					setModal={setCallModal}
					callTypeModal={"unit"}
					phone={item?.sales_rep?.phone}
				/>
			)}
			{messageModal && (
				<MessageModal
					modal={messageModal}
					setModal={setMessageModal}
					item={item}
					type="unit"
				/>
			)}
		</div>
	);
};

export default CardComponent;
